import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api } from '../../api/client';
import { Button, Field } from '../../components/ui';
import { useToast } from '../../components/Toast';
import BrandMark from '../../components/BrandMark';

export default function ForgotPassword() {
  const { t } = useTranslation();
  const toast = useToast();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  async function submit(event) {
    event.preventDefault();
    setBusy(true);
    try {
      await api.post('/api/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <Link to="/" className="auth-brand">
          <BrandMark />
          <strong>Nannies to the Rescue</strong>
        </Link>

        {sent ? (
          <>
            <h1>{t('auth.forgotPassword.checkEmailTitle')}</h1>
            <p className="muted">{t('auth.forgotPassword.checkEmailBody', { email })}</p>
            <p className="muted small">
              {t('auth.forgotPassword.nothingArrived')}{' '}
              <button type="button" className="link" onClick={() => setSent(false)}>{t('auth.forgotPassword.tryAnother')}</button>.
            </p>
            <Link className="btn btn-primary btn-block" to="/login">{t('auth.forgotPassword.backToSignIn')}</Link>
          </>
        ) : (
          <>
            <h1>{t('auth.forgotPassword.title')}</h1>
            <p className="muted">{t('auth.forgotPassword.lede')}</p>
            <form onSubmit={submit} noValidate>
              <Field label={t('auth.forgotPassword.email')} required>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                  required
                />
              </Field>
              <Button type="submit" loading={busy}>{t('auth.forgotPassword.emailMeLink')}</Button>
            </form>
            <p className="auth-alt">
              {t('auth.forgotPassword.rememberedIt')} <Link to="/login">{t('auth.forgotPassword.backToSignIn')}</Link>.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
